import { post } from '@/lib/request/index'
import { user } from '../apiConstants'

// 修改个人信息
export function updateUserInfo(param) {
  return post(user.UPDATE_USER_INFO, { param }).catch(err => {
    return err
  })
}
